export const PROFILE_UPDATED_NOTICE   = 'PROFILE_UPDATED_NOTICE';
export const USER_SAVED_NOTICE        = 'USER_SAVED_NOTICE';
export const USER_BLOCKED_NOTICE      = 'USER_BLOCKED_NOTICE';
export const USER_UNBLOCKED_NOTICE    = 'USER_UNBLOCKED_NOTICE';
export const STREAM_DELETED_NOTICE    = 'STREAM_DELETED_NOTICE';
export const STREAM_INFO_SAVED_NOTICE = 'STREAM_INFO_SAVED_NOTICE';
